<article
  class="personal-item"
  [class.personal-item--compact]="compact"
  #element
>
  <div class="personal-item__section">
    <header class="personal-item__section-header">
      @if (!compact) {
        <div class="checkbox">
          <input
            type="checkbox"
            [(ngModel)]="item.selected"
            (ngModelChange)="onSelect()"
            [id]="item.id"
          />
          <label [for]="item.id">
            <div class="checkbox__el"></div>
          </label>
        </div>
      }

      <h3
        class="personal-item__title"
        [tooltip]="
          ('BATCH_MAILING.RECEIPTS_TAB.RECEIPT' | translate) +
          ' №' +
          item.serial_number
        "
      >
        {{
          ('BATCH_MAILING.RECEIPTS_TAB.RECEIPT' | translate) +
            ' №' +
            item.serial_number
        }}
        <p class="personal-item__title-extra">
          {{
            ('BATCH_MAILING.RECEIPTS_TAB.CREATED_AT' | translate) +
              ': ' +
              dayjs(item?.created_at, 'YYYY-MM-DD HH:mm').format(
                'DD.MM.YYYY HH:mm'
              )
          }}
        </p>
      </h3>

      <table class="table batches-table">
        <thead>
          <tr>
            <th>{{ 'BATCH_MAILING.RECEIPTS_TAB.BATCH_IDS' | translate }}</th>
            <th>{{ 'BATCH_MAILING.RECEIPTS_TAB.BATCH_COUNT' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              @if (item?.batch_numbers?.length) {
                @for (
                  number of item.batch_numbers;
                  track number;
                  let i = $index
                ) {
                  <span>
                    {{ number
                    }}{{ i === item?.batch_numbers?.length - 1 ? '' : ', ' }}
                  </span>
                }
              } @else {
                {{ '-' }}
              }
            </td>
            <td [tooltip]="item?.lists?.length">{{ item?.lists?.length }}</td>
          </tr>
        </tbody>
      </table>
    </header>
    <div
      class="d-flex align-items-end"
      [ngClass]="{ 'flex-column justify-content-between': !compact }"
    >
      <div class="position-relative" [class.mr-3]="compact" dropdown>
        <button
          id="button-filter"
          dropdownToggle
          type="button"
          [disabled]="isDownloading$ | async"
          class="dropdown-toggle personal-item__section__button"
          aria-controls="dropdown-basic"
          [tooltip]="'BATCH_MAILING.RECEIPTS_TAB.DOWNLOAD_RECEIPT' | translate"
        >
          <span>{{
            'BATCH_MAILING.RECEIPTS_TAB.DOWNLOAD_RECEIPT' | translate
          }}</span>
        </button>
        <ul
          id="dropdown-filter"
          *dropdownMenu
          class="dropdown-menu"
          role="menu"
          aria-labelledby="button-filter"
        >
          <li role="menuitem">
            <button
              type="button"
              (click)="downloadInvoiceByType('pdf')"
              class="dropdown-item"
            >
              <span
                class="filter-button-icon"
                [inlineSVG]="'assets/img/icons/download.svg'"
              ></span>
              {{
                'BATCH_MAILING.RECEIPTS_TAB.DOWNLOAD_RECEIPT_PDF' | translate
              }}
            </button>
          </li>
          <li role="menuitem">
            <button
              type="button"
              (click)="downloadInvoiceByType('xlsx')"
              class="dropdown-item"
            >
              <span
                class="filter-button-icon"
                [inlineSVG]="'assets/img/icons/download.svg'"
              ></span>
              {{
                'BATCH_MAILING.RECEIPTS_TAB.DOWNLOAD_RECEIPT_XLSX' | translate
              }}
            </button>
          </li>
        </ul>
      </div>

      <button
        class="d-flex personal-item__section__button"
        type="button"
        [isDisabled]="isPrinting$ | async"
        [tooltip]="'FORMS.PRINT' | translate"
        (click)="print()"
      >
        <span>{{ 'FORMS.PRINT' | translate }}</span>
        <span
          class="filter-button-icon ml-2"
          [inlineSVG]="'assets/img/icons/printer-blue.svg'"
        ></span>
      </button>

      @if (printUrl) {
        <a
          [href]="printUrl | safe: 'resourceUrl'"
          target="_blank"
          #printBtn
          stopPropagation
          class="d-none"
        ></a>
      }
    </div>
  </div>
</article>
